import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Countdown as CountdownIcon, IconQuestion as IconQuestionIcon } from '~components/svgs';
import { Tooltip } from 'antd';
import { DEFAULT_COMPLETE_DUE_HOURS } from '~constants/payment';

const Countdown = ({ className, initTime, dueHours, tooltip }) => {
  const [time, setTime] = useState('00 : 00 : 00');
  const intervalRef = useRef();

  const formatNumber = num => {
    if (num) {
      if (Math.floor(num) > 9) {
        return Math.floor(num);
      }

      return '0'.concat(Math.floor(num));
    }

    return '00';
  };

  const getPaymentMoment = () => {
    const currentTime = moment.utc();
    const expireTime = moment.utc(initTime).add(dueHours, 'hours');
    const diff = expireTime - currentTime;

    if (diff >= 0) {
      const diffHour = diff / (1000 * 60 * 60);
      const diffMinute = (diffHour - Math.floor(diffHour)) * 60;
      const diffSecond = (diffMinute - Math.floor(diffMinute)) * 60;

      setTime(
        `${formatNumber(diffHour)} : ${formatNumber(diffMinute)} : ${formatNumber(diffSecond)}`,
      );
    } else {
      setTime('00 : 00 : 00');
    }
  };

  useEffect(() => {
    getPaymentMoment();
    intervalRef.current = setInterval(getPaymentMoment, 1000);

    return () => {
      if (intervalRef) {
        clearInterval(intervalRef.current);
      }
    };
  });

  return (
    <div className={`countdown ${className}`}>
      <div className="countdown__container">
        <CountdownIcon name="student-portal" className="countdown__moment-icon-tick" />
        <span className="countdown__moment-text">{time}</span>
        <If condition={tooltip}>
          <Tooltip title={tooltip}>
            <span className="countdown__tooltip-container">
              <IconQuestionIcon className="countdown__tooltip-icon" />
            </span>
          </Tooltip>
        </If>
      </div>
    </div>
  );
};

Countdown.propTypes = {
  className: PropTypes.string,
  initTime: PropTypes.string.isRequired,
  dueHours: PropTypes.number,
  tooltip: PropTypes.string,
};

Countdown.defaultProps = {
  className: '',
  tooltip: '',
  dueHours: DEFAULT_COMPLETE_DUE_HOURS,
};

export default Countdown;
